import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import HeroDeFi from "./HeroDeFi";
import WhatIsDeFi from "./WhatIsDeFi";
import DeFiStakingByXeer from "./DeFiStakingByXeer";
import FeaturesDeFi from "./FeaturesDeFi";
import LaunchDeFi from "./LaunchDeFi";
import WhyChooseXeer from "./WhyChooseXeer";
import JoinWithUs from "../../Home/JoinWithUs";

function DeFiStaking() {
  return (
    <div id="smooth-content">
      <Header />
      <HeroDeFi />
      <WhatIsDeFi />
      <DeFiStakingByXeer />
      <FeaturesDeFi />
      <LaunchDeFi />
      <div style={{ marginTop: "100px" }}>
        <JoinWithUs />
      </div>
      <WhyChooseXeer />
      <Footer />
    </div>
  );
}

export default DeFiStaking;
